import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import healthClaimFormAtom from '@/recoil/healthClaimForm/atom'
import { fetchDeleteClaim } from '@/services/healthClaim/useDeleteClaim'
import message from '@/libs/message'
import CONSTANT from '@/constant'
import { ClaimChannelEnum } from '@/constant/E_CLAIM'

export const DeleteClaimButtonHook = () => {
  const healthClaim = useRecoilValue(healthClaimFormAtom)
  const navigate = useNavigate()
  const [isOpenConfirmDeleteCase, setIsOpenConfirmDeleteCase] = useState<boolean>(false)

  const isBackofficeChannel = healthClaim.data?.claimChannel === ClaimChannelEnum.BACKOFFICE

  const handleToggleConfirmDelete = () => {
    setIsOpenConfirmDeleteCase(!isOpenConfirmDeleteCase)
  }

  const handleFetchDeleteClaim = () => {
    fetchDeleteClaim(healthClaim.data?.claimFormId || '')
      .then(() => {
        message.success('ลบข้อมูลสำเร็จ', 10).then(() => undefined)
        setIsOpenConfirmDeleteCase(false)
        setTimeout(() => {
          navigate(CONSTANT.ROUTES.HEALTH_CLAIM_PAGE)
        }, 500)
      })
      .catch(() => {
        message.error('ลบข้อมูลไม่สำเร็จ', 10).then(() => undefined)
        setIsOpenConfirmDeleteCase(false)
      })
  }

  return {
    // State
    isOpenConfirmDeleteCase,

    // Computed values
    isBackofficeChannel,

    // Handlers
    handleToggleConfirmDelete,
    handleFetchDeleteClaim,
  }
}
